{
  "metadata": {
    "id": "kanagawa-light",
    "name": "Kanagawa",
    "description": "Портировано из темы «Kanagawa» (light)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "light",
    "tags": [
      "light",
      "ported"
    ],
    "source": {
      "file": "kanagawa.json",
      "project": "rebelot",
      "url": "https://github.com/rebelot/kanagawa.nvim",
      "upstreamFile": "packages/ui/src/theme/themes/kanagawa.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.8,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.377,
      "paletteMaxS": 0.438,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 8.0,
      "surfacesTarget": 8.0,
      "surfacesRaisedTarget": 10.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 20.5,
      "syntaxVsTextMinDeltaE": 5.0,
      "chartsMinDeltaE": 32.2,
      "textSeparationDeltaE": 10.4,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "type",
          "b": "operator",
          "deltaE": 13.1
        }
      ],
      "modeLabel": "light",
      "modeFromLuminance": "light",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#2D4F67",
      "hover": "#28475d",
      "active": "#254154",
      "foreground": "#ffffff",
      "muted": "#2d4f6780",
      "emphasis": "#2D4F67"
    },
    "surface": {
      "background": "#F2E9DE",
      "foreground": "#2f2520",
      "muted": "#c7bbb0",
      "mutedForeground": "#423c36",
      "elevated": "#b2a59b",
      "elevatedForeground": "#483932",
      "raised": "#988a80",
      "raisedForeground": "#2d241f",
      "overlay": "#f2e9de33",
      "subtle": "#ddd2c8"
    },
    "interactive": {
      "border": "#93847a",
      "borderHover": "#c4b8ad",
      "borderFocus": "#2D4F67",
      "selection": "#54433a24",
      "selectionForeground": "#54433A",
      "focus": "#2d4f6759",
      "focusRing": "#2d4f6747",
      "cursor": "#54433a",
      "hover": "#54433a17",
      "active": "#54433a24"
    },
    "status": {
      "error": "#d21616",
      "errorForeground": "#ffffff",
      "errorBackground": "#d216161a",
      "errorBorder": "#d2161659",
      "warning": "#896121",
      "warningForeground": "#ffffff",
      "warningBackground": "#8961211a",
      "warningBorder": "#89612159",
      "success": "#556f33",
      "successForeground": "#ffffff",
      "successBackground": "#556f331a",
      "successBorder": "#556f3359",
      "info": "#5a7050",
      "infoForeground": "#ffffff",
      "infoBackground": "#5a70501a",
      "infoBorder": "#5a705059"
    },
    "pr": {
      "open": "#556f33",
      "draft": "#504942",
      "blocked": "#896121",
      "merged": "#ca6787",
      "closed": "#d21616"
    },
    "syntax": {
      "base": {
        "background": "#c7bbb0",
        "foreground": "#54433A",
        "comment": "#514942",
        "keyword": "#564176",
        "string": "#3f5326",
        "number": "#644718",
        "function": "#264e59",
        "variable": "#54433A",
        "type": "#713c4b",
        "operator": "#842e4a"
      },
      "tokens": {
        "commentDoc": "#514942",
        "stringEscape": "#842e4a",
        "keywordImport": "#564176",
        "storageModifier": "#564176",
        "functionCall": "#264e59",
        "method": "#264e59",
        "variableProperty": "#264e59",
        "variableOther": "#54433A",
        "variableGlobal": "#644718",
        "variableLocal": "#842e4a",
        "parameter": "#54433A",
        "constant": "#644718",
        "class": "#713c4b",
        "className": "#713c4b",
        "interface": "#713c4b",
        "struct": "#713c4b",
        "enum": "#713c4b",
        "typeParameter": "#713c4b",
        "namespace": "#713c4b",
        "module": "#564176",
        "tag": "#564176",
        "jsxTag": "#564176",
        "tagAttribute": "#264e59",
        "tagAttributeValue": "#3f5326",
        "boolean": "#644718",
        "decorator": "#564176",
        "label": "#264e59",
        "regexp": "#3f5326"
      }
    },
    "charts": {
      "series": [
        "#2D4F67",
        "#5a7050",
        "#3b7b27",
        "#896121",
        "#d21616"
      ]
    },
    "chat": {
      "background": "#F2E9DE",
      "userMessage": "#483932",
      "userMessageBackground": "#b2a59b",
      "assistantMessage": "#54433A",
      "assistantMessageBackground": "#c7bbb0",
      "timestamp": "#504942",
      "divider": "#93847a",
      "typing": "#504942"
    },
    "loading": {
      "spinner": "#2D4F67",
      "spinnerTrack": "#c7bbb0",
      "skeleton": "#c7bbb0",
      "shimmer": "#c0b4a9"
    },
    "tools": {
      "background": "#c7bbb0",
      "border": "#93847a",
      "headerHover": "#c1b5aa",
      "icon": "#2D4F67",
      "title": "#54433A",
      "description": "#504942",
      "edit": {
        "added": "#556f33",
        "addedBackground": "#556f331a",
        "removed": "#d21616",
        "removedBackground": "#d216161a",
        "modified": "#5a7050",
        "modifiedBackground": "#5a70501a",
        "lineNumber": "#504942"
      }
    },
    "markdown": {
      "heading1": "#54433A",
      "heading2": "#54433A",
      "heading3": "#54433A",
      "heading4": "#54433A",
      "link": "#2D4F67",
      "linkHover": "#28475d",
      "inlineCode": "#3f5326",
      "inlineCodeBackground": "#c7bbb0",
      "blockquote": "#504942",
      "blockquoteBorder": "#93847a",
      "listMarker": "#2d4f67bf",
      "bold": "#54433A",
      "italic": "#54433ae6",
      "strikethrough": "#504942",
      "hr": "#93847a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#7b4549",
        "foreground": "#ffffff",
        "contrast": 7.53
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bd735d",
        "foreground": "#000000",
        "contrast": 5.77
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c0a063",
        "foreground": "#000000",
        "contrast": 8.45
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bbc468",
        "foreground": "#000000",
        "contrast": 11.21
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#6d8f42",
        "foreground": "#000000",
        "contrast": 5.66
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#66c164",
        "foreground": "#000000",
        "contrast": 9.38
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#4a7f5f",
        "foreground": "#ffffff",
        "contrast": 4.67
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#67c294",
        "foreground": "#000000",
        "contrast": 9.72
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#67bec2",
        "foreground": "#000000",
        "contrast": 9.72
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#49717e",
        "foreground": "#ffffff",
        "contrast": 5.32
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#5b81bb",
        "foreground": "#000000",
        "contrast": 5.3
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#3c3f7e",
        "foreground": "#ffffff",
        "contrast": 9.53
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#765ab9",
        "foreground": "#ffffff",
        "contrast": 5.34
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#bd5fb9",
        "foreground": "#000000",
        "contrast": 5.5
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#7c4672",
        "foreground": "#ffffff",
        "contrast": 7.06
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#bc5d7e",
        "foreground": "#000000",
        "contrast": 5.01
      }
    ]
  }
}
